import { render } from "./CashdeskDatatableTDSalesCash.vue?vue&type=template&id=3be70610"
import script from "./CashdeskDatatableTDSalesCash.vue?vue&type=script&lang=js"
export * from "./CashdeskDatatableTDSalesCash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__